export default __webpack_public_path__ + "static/media/boss.38f17bbb.jfif";